export default "__VITE_ASSET__B_GSTun0__"